import type { SliceRouteContract } from '@/shared/lib/vsa';
import { ReservationsSlicePage } from './ReservationsSlicePage';

export const reservationsRouteContract: SliceRouteContract = {
  routeId: 'reservations',
  component: ReservationsSlicePage,
};
